// extracted by mini-css-extract-plugin
export default {"post":"BlogListItem_post__wReGj","post-meta":"BlogListItem_post-meta__hjQrS","post-link":"BlogListItem_post-link__GVBf+","divider":"BlogListItem_divider__tY9ua"};